var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { EmployeeStatus, Gender } from "../../model";
import { safeAssign } from "./safe-assign";
export class EmployeeDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], EmployeeDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], EmployeeDTO.prototype, "staffNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "lastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "callName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "address", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "city", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "postalCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "phone2", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], EmployeeDTO.prototype, "birthday", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "birthName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "birthCountry", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "nationality", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "gender", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "notes", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "avatar", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], EmployeeDTO.prototype, "timePin", void 0);
//# sourceMappingURL=employee.dto.js.map